import React, { useState, useEffect, useCallback, useContext } from "react";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { getClientesService } from "../../utils/ClienteService";
import { getProductosService } from "../../utils/ProductoService";
import { getServicioService } from "../../utils/ServicioService";
import { createVisitaService } from "../../utils/VisitasService";
import AuthContext from "../../context/AuthContext";
import ProductosForm from "../../components/visitas/ProductosForm";
import ClientesForm from "../../components/visitas/ClientesForm";
import ServiciosForm from "../../components/visitas/ServiciosForm";
import FechaAndPagoForm from "../../components/visitas/FechaAndPagoForm";
import swal from "sweetalert";

function CreateVisitaForm() {
  const { authTokens } = useContext(AuthContext);
  const navigate = useNavigate();

  // Fecha y forma de pago elegidos dentro del Modal.
  const [fecha, setFecha] = useState("");
  const [formaDePago, setFormaDePago] = useState(0);

  // Todos los clientes traidos desde la db y cliente elegido dentro del Modal.
  const [clientes, setClientes] = useState([]);
  const [selectedClient, setSelectedClient] = useState([]);
  const [largoPelo, setLargoPelo] = useState();

  // Productos traidos desde la db y productos seleccionados dentro del Modal.
  const [productos, setProductos] = useState([]);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [totalProductos, setTotalProductos] = useState();

  // Todos los servicios traidos de la db y servicios seleccionados dentro del Modal.
  const [servicios, setServicios] = useState([]);
  const [serviciosSeleccionados, setServiciosSeleccionados] = useState([]);
  const [totalServicios, setTotalServicios] = useState();

  // Pedimos todos los clientes a la db.
  const getClientes = useCallback(async () => {
    const clientes = await getClientesService(authTokens);
    setClientes(clientes ?? []);
  }, [authTokens]);

  // Pedimos todos los productos a la db.
  const getProductos = useCallback(async () => {
    const productos = await getProductosService(authTokens);
    setProductos(productos ?? []);
  }, [authTokens]);

  // Pedimos todos los servicios de la db.
  const getServicios = useCallback(async () => {
    const servicios = await getServicioService(authTokens);
    setServicios(servicios ?? []);
  }, [authTokens]);

  // Creamos una nueva Visita en la db
  const createVisita = useCallback(async (newVisita) => {
    createVisitaService(newVisita, authTokens).then((response) => {
      if (response) {
        navigate("/visitas");
      }
    });
  });

  const handleGuardarVisita = () => {
    if (
      selectedClient.length !== 0 &&
      (totalProductos !== 0 || totalServicios !== 0)
    ) {
      // Aca armamos los arrays de 'id' de los productos, servicios y forma de pago.
      let productos = [];
      let servicios = [];
      let f;

      if (parseInt(formaDePago) === 0) {
        f = "Efectivo";
      } else if (parseInt(formaDePago) === 1) {
        f = "Tarjeta";
      } else if (parseInt(formaDePago) === 2) {
        f = "Transferencia"
      } else {
        f = "Debe";
      }
      productosSeleccionados.map((p) => {
        productos.push({"id":p["id"], "precio":p["precio"]});
      });
      serviciosSeleccionados.map((s) => {
        servicios.push({"id":s["id"], "precio":s["precio"]});
      });
      
      const newVisita = {
        cliente: selectedClient.id,
        productos: productos,
        servicios: servicios,
        fecha: fecha,
        totalProductos: totalProductos,
        totalServicios: totalServicios,
        formaDePago: f,
        largoPelo: selectedClient.largo_pelo,
        info: selectedClient.info
      };
      
      createVisita(newVisita);
    } else {
      swal("Ingresar Cliente y al menos un Producto/Servicio", {
        button: false,
        icon: "warning",
        timer: "3000",
      });
    }
  };

  useEffect(() => {
    getClientes();
    getProductos();
    getServicios();
  }, []);

  return (
    <>
      <div className="mt-4  d-flex justify-content-between">
        <h4 className="pt-2">Registrar nueva Visita</h4>
        <div>
          <button className="btn btn-warning btn-sm m-1" onClick={()=>{navigate(-1)}}>
            Cancelar
          </button>
        </div>
      </div>

      <Form className="mt-3 mb-3">
        <hr />
        <FechaAndPagoForm
          fecha={fecha}
          setFecha={setFecha}
          setFormaDePago={setFormaDePago}
        />
        <hr />
        <ClientesForm
          clientes={clientes}
          setClientes={setClientes}
          setSelectedClient={setSelectedClient}
          selectedClient={selectedClient}
          setLargoPelo={setLargoPelo}
          setProductsList={setProductosSeleccionados}
          setServicesList={setServiciosSeleccionados}
        />
        <hr />
        <ProductosForm
          productos={productos}
          setProductos={setProductos}
          productsList={productosSeleccionados}
          setProductsList={setProductosSeleccionados}
          setTotalProductos={setTotalProductos}
          selectedClient={selectedClient}
          formaDePago={formaDePago}
          largoPelo={largoPelo}
        />
        <br />
        <hr />
        <ServiciosForm
          servicios={servicios}
          setServicios={setServicios}
          servicesList={serviciosSeleccionados}
          setServicesList={setServiciosSeleccionados}
          setTotalServicios={setTotalServicios}
          formaDePago={formaDePago}
          largoPelo={largoPelo}
          selectedClient={selectedClient}
        />
        <br />
        <hr />
        <div className="d-flex justify-content-around mt-4 container-fluid">
          {parseInt(formaDePago) === -1 ? (
            <h4 className="text-danger pt-2">
              Total a Cobrar: $ {totalProductos + totalServicios}{" "}
              <span className="badge rounded-pill bg-danger">Debe</span>
            </h4>
          ) : (
            <h4 className="text-success pt-2">
              Total a Cobrar: $ {totalProductos + totalServicios}
            </h4>
          )}
          <Button variant="info" type="button" onClick={handleGuardarVisita}>
            Guardar Visita
          </Button>
        </div>
      </Form>
    </>
  );
}

export default CreateVisitaForm;
